import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  MEDICAL_INSURANCE = "Medical insurance",
  LOANS = "Loans",
  LIVING_ACCOMMODATION = "Living accommodation",
  MEAL_ALLOWANCE = "Meal allowance",
  EDUCATION = "Education",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
  COMMUTER_ALLOWANCE = "Commuter allowance",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.MEAL_ALLOWANCE]: {
    text: "Maximum amount to be tax-exempt is ₹50 per meal.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.COMMUTER_ALLOWANCE]: {
    text: "Maximum amount to be tax-exempt is ₹1,600 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
